import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import DataContainer from '../../../Shared/DataContainer';
import DropdownButton from '../../../Shared/DropdownButton';
import Pagination from '../../../Shared/Pagination';
import Icon from '../../../Shared/Icon';
import { can, currencyFormat } from '../../../utils';
import ReactToPrint from "react-to-print";
import LoadingButton from '../../../Shared/LoadingButton';
import axios from "axios";

const Show = () => {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({});
     let componentRef = null;

     function handleAfterPrint() {
          Inertia.post(route('purchase.print', data.id)).then(() => {});
     }

     function handleSubmitDelivery(e) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('purchase.post.deliver', data.id), values).then(() => {
               setSending(false);
          });
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('purchase.delete', data.id), values).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="purchase-detail">
               <Helmet>
                    <title>Order Details</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('purchase.index')}>Purchase History</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Order Details</span>
               </div>
               <DataContainer>
                    <ReactToPrint
                         trigger={() => <a className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" href="#">Imprimer</a>}
                         content={() => componentRef}
                         onAfterPrint={() => handleAfterPrint()}
                    />
               <div className="float-right">
                    {(can(auth.user, 'make-delivery') && data.for_delivery) && (<form onSubmit={handleSubmitDelivery}>
                         <LoadingButton type="submit" loading={sending} className="float-right inline-flex items-center px-4 py-2 bg-gray-700 border border-transparent rounded-md font-semibold text-xs text-gray-100 uppercase tracking-widest hover:bg-gray-500 active:bg-gray-500 focus:outline-none focus:border-gray-500 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                              Send Out For Delivery
                         </LoadingButton>
                    </form>)}
                    {(can(auth.user, 'create-permission') && data.can_delete) && (<form onSubmit={handleSubmit}>
                         <LoadingButton type="submit" loading={sending} className="float-right inline-flex items-center px-4 py-2 bg-red-700 border border-transparent rounded-md font-semibold text-xs text-red-100 uppercase tracking-widest hover:bg-red-500 active:bg-red-500 focus:outline-none focus:border-red-500 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                              Delete Order
                         </LoadingButton>
                    </form>)}
               </div>
               </DataContainer>
               {data && (<React.Fragment key="anfen">
                    <div className="w-full bg-white" ref={el => (componentRef = el)}>
                         <div className="flex flex-col w-full p-8 text-gray-800 mt-2 pin-r pin-y text-sm">
                              <div className="flex w-full">
                                   <div className="w-1/2 px-3 py-3">
                                        <div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">No. Receipt <span className="font-semibold float-right text-gray-500">{data.number}</span></div>
                                        <div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">No. Reference <span className="font-semibold float-right text-gray-500">{data.reference}</span></div>
                                        <div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">No. MHD <span className="font-semibold float-right text-gray-500">{data.accpac}</span></div>
                                        {data.client && (<div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">Nom Client <span className="font-semibold float-right text-gray-500">{data.client.r_name}</span></div>)}
                                        {data.client && (<div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">Nom Acheteur <span className="font-semibold float-right text-gray-500">{data.client.s_name}</span></div>)}
                                        {data.client && data.client.address && (<div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">Nom Acheteur <span className="font-semibold float-right text-gray-500">{data.client.address}</span></div>)}
                                   </div>
                                   <div className="w-1/2 px-3 py-3">
                                        <div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">Date <span className="font-semibold float-right text-gray-500">{data.created}</span></div>
                                        <div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">Status <span className="font-semibold float-right text-gray-500" style={{color: `#${data.color}`}}>{data.status}</span></div>
                                        <div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">Method <span className="font-semibold float-right text-gray-500">{data.method}</span></div>
                                        {data.client && (<div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">No. Téléphone du Client <span className="font-semibold float-right text-gray-500">{data.client.phone}</span></div>)}
                                        {data.client && (<div className="font-semibold p-1 bg-gray-100 mt-2 text-gray-700">Pays Acheteur <span className="font-semibold float-right text-gray-500">{data.client.s_location?data.client.s_location:'Inconnu'}</span></div>)}
                                   </div>
                              </div>
                         </div>
                         <div className="w-full flex px-8 py-4 bg-white">
                              <table className="table-fixed w-full text-sm">
                                   <thead className="bg-gray-100">
                                        <tr>
                                             <th className="px-4 py-2"></th>
                                             <th className="px-4 py-2">Product</th>
                                             <th className="px-4 py-2">Quantity</th>
                                             <th className="px-4 py-2">Prix Ref.</th>
                                             <th className="px-4 py-2">Prix</th>
                                             <th className="px-4 py-2">Total</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {data.details.map(({id, name, type, category, code, currency, price, newprice, total, quantity, packs, image}) => {
                                             return <tr key={id}>
                                                  <td className="border px-4 py-2 text-center">
                                                       {image && (<img src={image} alt={name} className="w-8 rounded mx-auto" alt="Thumbnail" />)}
                                                       {!image && (<img className="w-8 rounded mx-auto" src={`https://ui-avatars.com/api/?name=${name}&amp;color=7F9CF5&amp;background=EBF4FF`} alt={name} />)}
                                                  </td>
                                                  <td className="border px-4">
                                                       {name} <span className="text-xs text-gray-500">({code})</span>
                                                       {packs && (<p className="ml-4 text-xs text-gray-600">{packs.join(' | ')}</p>)}
                                                  </td>
                                                  <td className="border px-4 py-2 text-center">{quantity}</td>
                                                  <td className="border px-4 py-2 text-right">{price.toFixed(2)}</td>
                                                  <td className="border px-4 py-2 text-center">{newprice.toFixed(2)}</td>
                                                  <td className="border px-4 py-2 text-right">{currencyFormat(total, currency)}</td>
                                             </tr>
                                        })}
                                   </tbody>
                                   <tfoot>
                                        <tr className="font-semibold">
                                             <td className="border px-4 py-2 text-right" colSpan="5">Total</td>
                                             <td className="border px-4 py-2 text-right" >{currencyFormat(data.amount, data.currency)}</td>
                                        </tr>
                                        <tr className="font-semibold">
                                             <td className="border px-4 py-2 text-right" colSpan="5">Livraison</td>
                                             <td className="border px-4 py-2 text-right" >{currencyFormat(data.delivery, data.currency)}</td>
                                        </tr>
                                        <tr className="font-bold">
                                             <td className="border px-4 py-2 text-right" colSpan="5">Total Payer</td>
                                             <td className="border px-4 py-2 text-right" >{currencyFormat(data.total, data.currency)}</td>
                                        </tr>
                                   </tfoot>
                              </table>
                         </div>
                    </div>
               </React.Fragment>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Show.layout = page => <AdminLayout children={page} header={'Order Details'} />;

export default Show;
